import { Chart, Grid } from 'components'
import { DCFilter } from 'types'
import { useBreakpoint } from 'utils'
import { StatTile } from '..'
import { useEvent, useOnTheGo } from '../../utils'
import { useAggregations } from '../../utils/analyticsUtils'
import { useWorkspaceSmartColumns } from '../../utils/lookupUtils'

export default function AnalyticsSmartColumnsSection() {
  const isMobile = useBreakpoint() < 2
  const { event, filters: eventFilters = [], setFilters: setEventFilters } = useEvent()
  const { filters: onTheGoFilters = [], setFilters: setOnTheGoFilters } = useOnTheGo()
  const existingFilters = event ? eventFilters : onTheGoFilters
  const setFilters = event ? setEventFilters : setOnTheGoFilters
  const smartColumnsWithCharts = useWorkspaceSmartColumns(undefined, true)
  const { aggregations } = useAggregations(
    smartColumnsWithCharts.map(smartCol => ({
      table: 'smartProperties',
      values: ['_count'],
      categories: ['text'],
      filters: [
        { field: 'name', operator: 'eq', value: smartCol, table: 'smartProperties' },
        { field: 'text', operator: 'isNull', value: false, table: 'smartProperties' },
        ...existingFilters,
      ],
      sort: { _count: 'DESC' },
      limit: 10,
    }))
  )

  const columnsWithAggregations = smartColumnsWithCharts
    .map((label, i) => {
      const aggregation = aggregations[i]
      const count = Number(aggregations[i].data?.[0]._count) ?? 0
      return { label, count, aggregation }
    })
    .filter(c => c.count)

  function handleSelect(smartCol: string, smartValue: string) {
    const selectedFilters: DCFilter = {
      field: 'text',
      operator: 'ILIKE',
      value: smartValue,
      table: 'smartProperties',
      secondaryTargetField: 'name',
      secondaryTargetValue: smartCol,
    }

    setFilters([...existingFilters, selectedFilters])
  }

  if (!columnsWithAggregations.length) return null

  return (
    <Grid templateColumns={['1fr', null, 'repeat(2, 1fr)']} gap={6}>
      {columnsWithAggregations.map(({ label: smartCol, count, aggregation }) => (
        <StatTile
          key={smartCol}
          alignItems="stretch"
          height="350px"
          label={smartCol}
          num={count}
          canCopy
        >
          <Chart
            {...aggregation}
            orientation={count <= 5 ? 'column' : 'bar'}
            onSelect={
              isMobile
                ? undefined
                : ({ label: smartValue }) => {
                    handleSelect(smartCol, smartValue)
                  }
            }
          />
        </StatTile>
      ))}
    </Grid>
  )
}
